<template>
  <div>
    <b-card-text class="mb-2 d-flex justify-content-between">
      <b-button-group>
        <b-button
          v-for="button in buttons"
          :key="button.type"
          variant="outline-primary"
          :class="{ ['bg-primary text-white']: buttons.length === 1 || data.type === button.type }"
          @click="handleChangeType(button.type)"
        >
          {{ $t(button.label) }}
        </b-button>
      </b-button-group>
    </b-card-text>
    <slot />
  </div>
</template>

<script>
import { BCardText, BButton, BButtonGroup } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCardText,
    BButtonGroup,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    buttons: {
      type: Array,
      required: false,
      default: () => [
        { type: 'chat', label: 'field.chat' },
        { type: 'call', label: 'breadcrumb.call' },
      ],
    },
  },
  data() {
    return {
      data: {
        type: this.$route.query.type || 'chat',
      },
      queries: {
        chat: {},
        call: {},
      },
    }
  },
  watch: {
    '$route.query': {
      handler(newQuery) {
        this.queries[this.data.type] = { ...newQuery }
      },
      deep: true,
    },
  },
  methods: {
    handleChangeType(type) {
      this.queries[this.data.type] = { ...this.$route.query }
      this.data.type = type
      this.$router.replace({ query: { ...this.queries[type], type } })
    },
  },
}
</script>
